import _ from 'lodash';
import { getImageStyle } from 'shared/utils/getImageStyle';

export const getInitialValues = userProfile => {
  let values = userProfile;

  if (!_.isNil(userProfile.country)) {
    const countryChoice = {
      label: userProfile.country.name,
      value: userProfile.country.id
    };
    values = Object.assign({}, values, { country: countryChoice });
  }

  if (!_.isNil(_.get(userProfile, 'profile.position'))) {
    const { position } = userProfile.profile;

    const positionChoice = {
      value: position.id,
      label: position.name
    };

    values = Object.assign({}, values, {
      profile: { ...values.profile, position: positionChoice }
    });
  }

  if (!_.isEmpty(userProfile.sectors)) {
    const sectorsChoices = userProfile.sectors.map(sector => {
      return {
        value: sector.id,
        label: sector.name
      };
    });
    values = Object.assign({}, values, { sectors: sectorsChoices });
  }

  return values;
};

export const getAvatarStyle = (avatar, thumbnails, avatarPreview) => {
  if (!_.isNil(avatarPreview)) {
    return {
      backgroundImage: `url(${avatarPreview})`,
      backgroundSize: 'cover'
    };
  }

  return getImageStyle({
    image: avatar,
    thumbnails,
    width: 90,
    height: 90
  });
};
